import React from 'react';

import { flagStyles } from '../settings';

const SvgMV = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3672px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMV;
